import store from "../store";

const state = () => ({
  filters: {
    // Make sure to update resetFilters
    campaigns: {
      channels: 0,
      status: 1
    },
    // Make sure to update resetFilters
    campaignCosts: {
      sortOption: null
    },
    // Make sure to update resetFilters
    campaignUnitCounts: {
      sortOption: null
    },
  },
});

const getters = {};

const mutations = {
  // Set one filter
  setOneFilter(state, [filterName, filter, value]) {
    state.filters[filterName][filter] = value;
    store.dispatch('updateUserAppFilter')
  },
  setUserFilters(state, filters) {
    // make sure this match the filters declared on state
    state.filters = filters
  },
  // Reset filters
  resetCampaignsFilters(state) {
    // Make sure to update state default
    state.filters.campaigns = {
      channels: 0,
      status: 1
    };

    store.dispatch('updateUserAppFilter')
  },
  resetCampaignCostsFilters(state) {
    // Make sure to update state default
    state.filters.campaignCosts = {
      sortOption: null
    };
  },
  resetCampaignUnitCountsFilters(state) {
    // Make sure to update state default
    state.filters.campaignUnitCounts = {
      sortOption: null
    };
  },
};

const actions = {};

const CampaignsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default CampaignsStore;
